import gql from 'graphql-tag'

import { AppGetDisclaimersQuery } from '../../../types/api'

export default {
  query: gql`
    query AppGetDisclaimers {
      rdvDisclaimer {
        disclaimerEn
        disclaimerFr
      }
    }
  `,
  transformer: (response: AppGetDisclaimersQuery) => {
    return response.rdvDisclaimer
  },
}
